export default "__VITE_ASSET__33702ed7__"